import { render, staticRenderFns } from "./SecondaryButton.vue?vue&type=template&id=22711658&scoped=true"
import script from "./SecondaryButton.vue?vue&type=script&lang=js"
export * from "./SecondaryButton.vue?vue&type=script&lang=js"
import style0 from "./SecondaryButton.vue?vue&type=style&index=0&id=22711658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22711658",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SecondaryButton.vue
// module id = 124
// module chunks = 0